export default __webpack_public_path__ + "static/employeeSpouse-e6bcbd6fbb82b92f243bebf25ef8ced3.svg";